import { GlobalStatesV3 } from '../states/GlobalStatesV3';
import { CurrentUserState } from '../../mainv2/states/CurrentUserState';

export const useCurrentUserState = (): CurrentUserState => {
  return GlobalStatesV3.currentUser;
};
